import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { clearClientSideCacheStates } from '@/state';
import {
  deleteTenantLS,
  getTenantLS,
  setTenantLS,
} from '@/lib/org/tenant-storage';

export const useClientSideCache = () => {
  const dispatch = useDispatch();

  const deleteCurrentTenant = useCallback(() => {
    // dispatch(setTenant(null));
    deleteTenantLS();
  }, [dispatch]);

  const clearClientSideCacheData = useCallback(() => {
    dispatch(clearClientSideCacheStates());
    deleteTenantLS();
  }, [dispatch]);

  const setCurrentTenant = useCallback(
    (tenant: string) => {
      // dispatch(setTenant(tenant));
      setTenantLS(tenant);
    },
    [dispatch]
  );

  return {
    deleteCurrentTenant,
    clearClientSideCacheData,
    tenant: getTenantLS(),
    setCurrentTenant,
  };
};
